import angular from "angular";
import "../../../services/cart";
import '../../../directives/register-form';

angular.module("folkeuni").component("organization", {
  bindings: {
    cart: "=",
    state: "<",
  },
  controller: function (
    $location,
    $window,
    Cart,
    $rootScope,
    $scope,
    $element
  ) {
    var $ctrl = this;

    $ctrl.initOrganizationTickets = function () {
      if (!$ctrl.cart || !$ctrl.cart.products) return;
      var checkoutTickets =
        $ctrl.cart.checkout && Array.isArray($ctrl.cart.checkout.tickets)
          ? $ctrl.cart.checkout.tickets
          : [];
      var idx = 0;
      $ctrl.cart.products.forEach(function (product) {
        if (product.organization && Array.isArray(product.tickets)) {
          product.tickets.forEach(function (ticket) {
            var data = checkoutTickets[idx] || {};
            ticket.organization =
              typeof data.organization === "string" ? data.organization : "";
            ticket.jobTitle =
              typeof data.jobTitle === "string" ? data.jobTitle : "";
            idx++;
          });
        }
      });
    };

    $ctrl.validateTicketData = function () {
      var valid = true;
      var checkoutTickets = [];
      if (!$ctrl.cart || !$ctrl.cart.products) return true;
      $ctrl.cart.products.forEach(function (product) {
        if (product.organization && Array.isArray(product.tickets)) {
          product.tickets.forEach(function (ticket) {
            var org = (ticket.organization || "").trim();
            var job = (ticket.jobTitle || "").trim();
            checkoutTickets.push({ organization: org, jobTitle: job });
            if (org.length >= 2 && job.length >= 1) {
              ticket.invalid = false;
            } else {
              ticket.invalid = true;
              valid = false;
            }
          });
        }
      });
      // Gem arrayet i checkout.tickets
      if (!$ctrl.cart.checkout) $ctrl.cart.checkout = {};
      $ctrl.cart.checkout.tickets = checkoutTickets;
      return valid;
    };

    var organizationChangedTimeout;
    $ctrl.organizationChanged = function () {
      if (organizationChangedTimeout) {
        clearTimeout(organizationChangedTimeout);
      }
      organizationChangedTimeout = setTimeout(function () {
        Cart.customerInfoLocalStorageSet($ctrl.cart);
      }, 400);
    };

    $ctrl.$onInit = function () {
      $ctrl.initOrganizationTickets();
      $ctrl.validateTicketData();
      if (
        $scope.$parent &&
        $scope.$parent.$ctrl &&
        $scope.$parent.$ctrl.registerValidityChecker
      ) {
        $scope.$parent.$ctrl.registerValidityChecker($ctrl.isValid);
      }
      if (typeof $rootScope !== "undefined") {
        $rootScope.$on("cart.update", function (evt, cart) {
          $ctrl.cart = cart;
          $ctrl.initOrganizationTickets();
          $ctrl.validateTicketData();
        });
      }
    };

    $ctrl.isValid = function () {
      return $ctrl.validateTicketData();
    };

    $scope.ticketForms = {};
    $scope.registerForm = function (index, form) {
      $scope.ticketForms[index] = form;
    };

    $scope.$on("checkout:showAllErrors", function () {
      angular.forEach($scope.ticketForms, function (form) {
        if (form) {
          angular.forEach(form, function (field) {
            if (field && field.$setTouched) field.$setTouched();
            if (field && field.$validate) field.$validate();
          });
        }
      });
    });
  },

  templateUrl: "/shop-dist/templates/organization.html?c=" + window.cacheBurst,
  transclude: true,
});
